import { render, staticRenderFns } from "./tableForModel.vue?vue&type=template&id=19f7282f&scoped=true"
import script from "./tableForModel.vue?vue&type=script&lang=js"
export * from "./tableForModel.vue?vue&type=script&lang=js"
import style0 from "./tableForModel.vue?vue&type=style&index=0&id=19f7282f&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f7282f",
  null
  
)

export default component.exports